
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import { ChildComponentMixin } from '@/mixins'
import IntegrationsDraggableTableRow from '@/components/IntegrationsDraggableTableRow.vue'
import Draggable from 'vuedraggable'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        Draggable,
        IntegrationsDraggableTableRow,
    },
})
export default class IntegrationsDraggableTable extends ChildComponentMixin {
    @Prop() private value?: IntegrationModuleEntity[]
    @Prop() private disabled!: boolean

    get rows() {
        return this.value ? this.value : []
    }

    get headers(): string[] {
        return ['', 'Aplicação', 'Desenvolvedor', 'Categoria', 'Status', '', '']
    }

    public async onChangeTable() {
        const params = this.rows.map((row: IntegrationModuleEntity, index: number) => {
            return row.id
        })

        await this.$store.dispatch('integration/orderIntegrationModules', params)
    }
}
